/** Bottom-sheet-on-mobile / centered-on-wide overlay. Click on the backdrop closes it. */
export default function Modal({ title, onClose, children }) {
  return (
    <div class="etm-modal-overlay" onClick={onClose}>
      <div class="etm-modal" onClick={(e) => e.stopPropagation()}>
        {title ? <h2 class="etm-modal__title">{title}</h2> : null}
        {children}
      </div>
    </div>
  );
}
